export default __webpack_public_path__ + "static/media/quote.11b7aaad.svg";